import {combine} from 'effector';
import {Driver} from 'neo4j-driver';

import {clearTracingGridCache, fetchTracingGrid} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {TracingGridRowRaw} from 'types';
import {SimplePaginationContent} from 'types/api';
import {getFirstDayOfMonth, getLastDayOfMonth} from 'utils/date';

const domain = rootDomain.createDomain('TracingGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchTracingGridFx',
    handler: fetchTracingGrid,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearTracingGridCache,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<SimplePaginationContent<TracingGridRowRaw> | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore<string>('').on(searchChanged, (_, value) => value);

export const periodChanged = domain.createEvent<[Date | null, Date | null]>();
export const period$ = domain
    .createStore<[Date | null, Date | null]>([getFirstDayOfMonth(), getLastDayOfMonth()])
    .on(periodChanged, (_, value) => value);

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    period: period$,
    dataLoading: fetchDataFx.pending,
});
